import React from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { useDarkMode } from '../App'

const LanguageSwitcher: React.FC = () => {
  const { language, toggleLanguage, isRTL } = useLanguage()
  const { isDark } = useDarkMode()

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center space-x-2 px-2 sm:px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        isDark 
          ? 'text-gray-300 hover:text-white hover:bg-gray-800' 
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
      }`}
      aria-label={`Switch to ${language === 'en' ? 'Arabic' : 'English'}`}
      title={`Switch to ${language === 'en' ? 'العربية' : 'English'}`}
    >
      {/* Language Icon */}
      <svg 
        className="w-4 h-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" 
        />
      </svg>
      
      {/* Language Label - Hidden on very small screens */}
      <span className={`hidden sm:inline ${isRTL ? 'mr-2 ml-0' : 'ml-2 mr-0'}`}>
        {language === 'en' ? 'العربية' : 'English'}
      </span>
    </button>
  )
}

export default LanguageSwitcher